import "../styles/ShowFiltersButton.css"

const ShowFiltersButton = ({ onClick }) => {
  return (
    <button
      className="show-filters-button"
      onClick={onClick}
    >
      Показать фильтры
    </button>
  );
};

export default ShowFiltersButton;
